import axios from 'axios'
import type { EntitySchema } from '@/features/list-page/schema/types'

/**
 * Backend-facing API for the entity schema endpoints. Responses match the
 * contract defined in openspec/changes/add-schema-driven-list-page/sprint-1-backend-design.md
 * (section 9 — JSON contract).
 *
 * The endpoints are read-only and do not require any business parameters.
 * Axios's response interceptor unwraps the `{code, data, msg}` envelope, so
 * the typed return matches the response.data shape directly.
 */

export interface EntityTypeBrief {
  entity_type: string
  display_name: string
  module: string
  /** REST base path (e.g. `/pms/tasks`) — null when not list-page enabled. */
  base_path?: string | null
}

export interface EntityTypeListResponse {
  entity_types: EntityTypeBrief[]
}

export const entitySchemaApi = {
  /** GET /system/entity-schema/ — list all registered entity types. */
  listEntityTypes: (): Promise<EntityTypeListResponse> =>
    axios.get('/system/entity-schema/'),

  /**
   * GET /system/entity-schema/{entity_type} — full field metadata for an entity.
   *
   * Returns null when the backend returns 404 (entity not registered) so callers
   * can decide whether to fall back to lookup-table mode without try/catch.
   */
  getEntitySchema: async (entityType: string): Promise<EntitySchema | null> => {
    try {
      const response = await axios.get(`/system/entity-schema/${entityType}`)
      return response as unknown as EntitySchema
    } catch (err: any) {
      if (err?.response?.status === 404) return null
      throw err
    }
  },
}
